<template>
	<div :title="hint">
		<input
			class="input"
			:placeholder="title"
			:type="type"
			:name="name"
			:value="value"
			@input="$emit('input', $event.target.value)"
			>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'text',
			},

			name: String,
			value: String,
			hint: String,
			title: String,
		},
	};
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.input {
	padding: 5px;
	width: 100%;
	box-sizing: border-box;

	border: 1px solid @color-chat-1;
	border-radius: 2px;
	background-color: @color-chat-2;
}
</style>
